import React from 'react';
import { Box, Typography } from '@mui/material';

import { IGuideItem } from './interfaces';
import { useStyles } from './styles';

const GuideItem = ({ label, icon }: IGuideItem) => {
  const classes = useStyles();

  return (
    <Box sx={classes.root}>
      {icon}
      <Typography sx={classes.label}>{label}</Typography>
    </Box>
  );
};

export default GuideItem;
